import { v1 } from 'uuid';

export const uuid = () => v1();
